

import { Observable } from 'rxjs';
import { Parameter } from '../../../../../@core/interfaces/common/parameter';


export interface PoStatusMstParameter extends Parameter {
    searchTerm: number;
    orderBy: string;  
}
export interface PoStatusMst {
    id?:number;
    poStatus:string;
    poDescription:string;  
   
    createdIp:string;
 
    createdBy:number;
    createdDate:Date
    tenantId:any;
    branchId:any;
      
    parameters?: PoStatusMstParameter[];
    links?: any;
}

export abstract class PoStatusMstData { 
    abstract list(url: string): Observable<PoStatusMst[]>;
    abstract create(url: string,data: PoStatusMst): Observable<any>;
    abstract update(url: string,data: PoStatusMst): Observable<any>;
    abstract delete(url: string): Observable<any>;
}
